import type { CSSProperties, PropsWithChildren } from "react";

import { cn } from "@/lib/utils";

type SectionRevealProps = PropsWithChildren<{
  className?: string;
  delay?: number;
}>;

export function SectionReveal({
  children,
  className,
  delay = 0,
}: SectionRevealProps) {
  return (
    <div
      data-reveal
      data-reveal-state="visible"
      style={
        {
          "--reveal-delay": `${Math.max(0, delay)}s`,
        } as CSSProperties
      }
      className={cn("reveal-section", className)}
    >
      {children}
    </div>
  );
}
